import React, { useState, useEffect } from "react";
import { Save } from "lucide-react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function OurJourneyForm({
  data = {},
  onSave,
  apiBase = `${API_BASE_URL}/about`,
}) {
  const [title, setTitle] = useState(data.title || "Our Journey");
  const [timeline, setTimeline] = useState([
    { title: "", year: "", event: "" },
    { title: "", year: "", event: "" },
    { title: "", year: "", event: "" },
    { title: "", year: "", event: "" },
    { title: "", year: "", event: "" },
  ]);

  // Pre-fill data if available
  useEffect(() => {
    if (data.timeline) {
      try {
        const parsed =
          typeof data.timeline === "string"
            ? JSON.parse(data.timeline)
            : data.timeline;
        if (Array.isArray(parsed) && parsed.length > 0) {
          const updated = [...timeline];
          parsed.slice(0, 5).forEach((item, i) => {
            updated[i] = {
              title: item.title || "",
              year: item.year || "",
              event: item.event || "",
            };
          });
          setTimeline(updated);
        }
      } catch (err) {
        console.error("Error parsing timeline data:", err);
      }
    }
  }, [data]);

  // Handle change in each field
  const handleChange = (index, field, value) => {
    const updated = [...timeline];
    updated[index][field] = value;
    setTimeline(updated);
  };

  // Save
  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Session expired. Please log in again.");
        return;
      }

      const payload = {
        title,
        timeline,
      };

      const res = await fetch(`${apiBase}/journey`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to save journey timeline.");

      alert("Journey section saved successfully!");
      onSave?.(payload);
    } catch (error) {
      console.error("Error saving journey timeline:", error);
      alert("Failed to save. Check console for details.");
    }
  };

  return (
    <section className="bg-white rounded-xl shadow p-8 mb-10">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-blue-700">{title}</h2>
        <button
          onClick={handleSave}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg"
        >
          <Save size={18} /> Save
        </button>
      </div>

      {/* Fixed 5 rows */}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded-lg">
          <thead className="bg-gray-100 text-gray-700 text-sm">
            <tr>
              <th className="px-4 py-2 border text-center">No.</th>
              <th className="px-4 py-2 border text-left">Title</th>
              <th className="px-4 py-2 border text-left">Year</th>
              <th className="px-4 py-2 border text-left">Event Description</th>
            </tr>
          </thead>
          <tbody>
            {timeline.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-4 py-2 border text-center font-medium">
                  {index + 1}
                </td>
                <td className="px-4 py-2 border">
                  <input
                    type="text"
                    value={item.title}
                    onChange={(e) =>
                      handleChange(index, "title", e.target.value)
                    }
                    className="w-full border rounded-md px-2 py-1 focus:ring-2 focus:ring-blue-400 outline-none"
                    placeholder="Milestone Title"
                  />
                </td>
                <td className="px-4 py-2 border">
                  <input
                    type="text"
                    value={item.year}
                    onChange={(e) =>
                      handleChange(index, "year", e.target.value)
                    }
                    className="w-full border rounded-md px-2 py-1 focus:ring-2 focus:ring-blue-400 outline-none"
                    placeholder="Year"
                  />
                </td>
                <td className="px-4 py-2 border">
                  <textarea
                    value={item.event}
                    onChange={(e) =>
                      handleChange(index, "event", e.target.value)
                    }
                    className="w-full border rounded-md px-2 py-1 focus:ring-2 focus:ring-blue-400 outline-none resize-y"
                    rows={2}
                    placeholder="Describe what happened this year..."
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
